import { defineMessages } from "react-intl"
import _ from "lodash"

export const msg = defineMessages({
  unauthorized: {
    id: "action.errors.notlogged",
    defaultMessage: "Please log in first"
  },
  invalidCredentials: {
    id: "action.errors.badcredentials",
    defaultMessage: "Invalid credentials. Please retry."
  },
  inactiveAccount: {
    id: "action.errors.inactiveuser",
    defaultMessage:
      "Your account is deactivated. Please request a new password or contact an administrator."
  },
  duplicatedAccount: {
    id: "actions.errors.duplicatedAccount",
    defaultMessage:
      "Multiple accounts with this email have been detected, please use your ID to log in."
  },
  wrongPassword: {
    id: "action.errors.wrongPassword",
    defaultMessage: "Wrong password"
  },
  notFound: {
    id: "action.errors.not found",
    defaultMessage: "Not Found"
  },
  alreadyExists: {
    id: "action.errors.alreadyExist",
    defaultMessage: "Already exist"
  },
  internalSrvError: {
    id: "action.errors.internal",
    defaultMessage: "Internal server error"
  },
  noBackend: {
    id: "action.errors.unavailable",
    defaultMessage: "The server is unavailable. Please try again later"
  },
  noSMTPService: {
    id: "action.errors.smtpunavailable",
    defaultMessage: "SMTP is unavailable. Please try again later"
  },
  invalidSMTPConfiguration: {
    id: "action.errors.smtpInvalidConfiguration",
    defaultMessage: "SMTP configuration invalid"
  },
  tooManyInviteErr: {
    id: "invite.too.many.contacts",
    defaultMessage:
      "Multiple contacts have the same email, and no Web Portal ID is present. Please enter a Web Portal ID in the contact's profile or change the email address."
  },
  invalidMailInvite: {
    id: "invite.contact.with.invalid.mail",
    defaultMessage:
      "Selection contains contact without (or invalid) email. No email sent."
  },
  pathSharedResourceNotFound: {
    id: "shared.resource.path.directory.not.found",
    defaultMessage: "Directory path not exist."
  },
  pathSharedResourceNotExistZipFiles: {
    id: "shared.resource.path.directory.zip.not.exist",
    defaultMessage: "The directory does not contain zip files."
  },
  formsAlreadyPublished: {
    id: "form.publication.invalid.selection",
    defaultMessage: "Some form have already been published."
  },
  formsAlreadySavedByUser: {
    id: "form.bulk.deletion.error",
    defaultMessage:
      "Some users have already viewed and submitted the selected form(s). The selected form(s) can no longer be deleted."
  },
  remainingTries: {
    id: "login.form.remainingTries",
    defaultMessage:
      "After several failed attempts, your account will be disabled ({remainingTries} remaining)"
  },
  fundSummaryWrongFormat: {
    id: "fund.summary.wrongformat",
    defaultMessage: "Wrong format passed for Funds Summary widget."
  },
  invalidEmail: {
    id: "invite.contact.invalidEmail",
    defaultMessage: ""
  },
  contactSyncFailed: {
    id: "admin.error.sync.contact",
    defaultMessage: ""
  },
  tagsSyncFailed: {
    id: "admin.error.sync.tags",
    defaultMessage: ""
  },
  attributesSyncFailed: {
    id: "admin.error.sync.attributes",
    defaultMessage: ""
  },
  fundsSyncFailed: {
    id: "admin.error.sync.funds",
    defaultMessage: ""
  },
  removeUnusedSessionSyncFailed: {
    id: "admin.error.sync.removeUnusedSession",
    defaultMessage: ""
  }
})

// 400 Errors
const EmailValidationError = { type: 400, message: msg.invalidMailInvite }
const EmailSentError = { type: 400, message: msg.invalidSMTPConfiguration }

const PathSharedResourceNotFound = {
  type: 400,
  message: msg.pathSharedResourceNotFound
}
const PathSharedResourceNotExistZipFiles = {
  type: 400,
  message: msg.pathSharedResourceNotExistZipFiles
}

const UnauthorizedError = {
  type: 401,
  subType: "UnauthorizedError",
  message: msg.unauthorized
}
const InactiveAccountError = { type: 401, message: msg.inactiveAccount }
const DuplicatedAccountError = { type: 401, message: msg.duplicatedAccount }
const RemainingTriesAccountError = { type: 401, message: msg.remainingTries }
const NotFoundError = { type: 404, message: msg.notFound }
const AlreadyExistError = { type: 409, message: msg.alreadyExists }
const NotFoundResourceError = { type: 404, message: "" }

const WrongPasswordError = { type: 412, message: msg.wrongPassword }
// 500 Errors
const InternalServerError = { type: 500, message: msg.internalSrvError }
const NoBackendError = { type: 500, message: msg.noBackend }
const SMTPConnectionError = { type: 500, message: msg.noSMTPService }
const TooManyContactFound = { type: 500, message: msg.tooManyInviteErr }
const FormsAlreadySavedByUser = {
  type: 500,
  message: msg.formsAlreadySavedByUser
}
const WrongFundFormat = {
  type: 500,
  message: msg.formsAlreadySavedByUser
}
const contactSyncFailed = {
  type: 500,
  message: msg.contactSyncFailed
}
const tagsSyncFailed = {
  type: 500,
  message: msg.tagsSyncFailed
}
const attributesSyncFailed = {
  type: 500,
  message: msg.attributesSyncFailed
}
const fundsSyncFailed = {
  type: 500,
  message: msg.fundsSyncFailed
}
const removeUnusedSessionSyncFailed = {
  type: 500,
  message: msg.removeUnusedSessionSyncFailed
}

function unauthorizedErrorHandler(error) {
  if (error.response && error.response.data && error.response.data.error) {
    switch (error.response.data.error.message) {
      case "Invalid credentials":
        return {
          ...RemainingTriesAccountError,
          remainingTries: error.response.data.error.remainingTries
        }
      case "Account is disabled":
        return InactiveAccountError
      case "Account is duplicated":
        return DuplicatedAccountError
      default:
    }
  }
  return UnauthorizedError
}

/**
 * Global server error handler when http error code = 500.
 * Code can be used by backend to specify a code that could be handle properly by frontend.
 * @param error
 */
function serverErrorHandler(error) {
  const errorCode = _.get(error, "response.data.error.code")
  if (!errorCode) {
    return InternalServerError
  }

  switch (errorCode) {
    case "invite_too_many_contact_with_mail":
      return TooManyContactFound
    case "smtp_error_connection":
      return SMTPConnectionError
    case "forms_already_saved_by_user":
      return FormsAlreadySavedByUser
    case "wrong_fund_format":
      return WrongFundFormat
    case "admin.error.sync.contact":
      return contactSyncFailed
    case "admin.error.sync.tags":
      return tagsSyncFailed
    case "admin.error.sync.attributes":
      return attributesSyncFailed
    case "admin.error.sync.funds":
      return fundsSyncFailed
    case "admin.error.sync.removeUnusedSession":
      return removeUnusedSessionSyncFailed
    default:
      return InternalServerError
  }
}

/**
 * Customize default Bad Request error handler.
 * @param error
 */
function badRequestErrorHandler(error) {
  const errorCode = _.get(error, "response.data.code")
  if (errorCode === "email_validation_error") {
    return EmailValidationError
  }
  if (errorCode === "mailer_config_error") {
    return EmailSentError
  }
  if (errorCode === "path_shared_resource_not_found_error") {
    return PathSharedResourceNotFound
  }
  if (errorCode === "path_shared_resource_not_exist_zip_files_error") {
    return PathSharedResourceNotExistZipFiles
  }
  if (errorCode === "duplicate_form_error") {
    const errorMessage = _.get(error, "response.data.message")

    return {
      type: 500,
      message: errorMessage
    }
  }
  return error
}

function noServiceFound(error) {
  if (process.env.NODE_ENV === "test" && error.message.startsWith("Nock")) {
    // do not encapsulate this one, rethrow it to make test clearer
    throw error
  }
  return NoBackendError
}
function NotFoundResourceErrorHandler(error) {
  const errorCode = _.get(error, "response.data.code")
  const errorMsg = _.get(error, "response.data.message")

  if (
    errorCode === "resource_not_found_error" ||
    errorCode === "resource_file_not_found_error"
  ) {
    NotFoundResourceError.message = errorMsg
    return NotFoundResourceError
  }

  return NotFoundError
}
export default (error) => {
  if (!error.response) {
    // Backend Unavailable
    return noServiceFound(error)
  }

  switch (error.response.status) {
    case 400:
      return badRequestErrorHandler(error)
    case 401:
      return unauthorizedErrorHandler(error)
    case 404:
      return NotFoundResourceErrorHandler(error)
    case 409:
      return AlreadyExistError
    case 412:
      return WrongPasswordError
    case 500:
      return serverErrorHandler(error)
    default:
      return error
  }
}
